import "./index.scss";
import { useState } from "react";
import { ReactComponent as FilterIcon } from "assets/filter-icon.svg";
import { ReactComponent as DropdownArrow } from "assets/dropdown-arrow.svg";
import { OutsideClickHandler } from "..";

export const DiscountSort = ({ sortList, sorting, setSorting, setPage }) => {
  const [sortOpen, setSortOpen] = useState(false);

  const handleSortItemClick = (option) => {
    setPage(1);
    setSorting(option);
    setSortOpen(false);
  };

  return (
    <div className={`discount-filter-sort ${sortOpen ? "open" : "closed"}`}>
      <div className="filter-title">
        <FilterIcon
          width="19"
          height="20"
          alt="filter icon"
          className="filter-icon"
        />
        <p>Filter</p>
      </div>
      <OutsideClickHandler onOutsideClick={() => setSortOpen(false)}>
        <button className="dropdown" onClick={() => setSortOpen(!sortOpen)}>
          <div className="dropdown-selection">
            <div className="dropdown-option">
              <span>{sorting.selector}</span>
              :&nbsp;{sorting.label}
              <DropdownArrow
                alt="dropdown arrow"
                width="11"
                height="7"
                className="dropdown-arrow"
              />
            </div>
          </div>
        </button>

        <div className="dropdown-list">
          {sortList.map((option) => {
            const isHighlighted = option === sorting;

            return (
              <button
                key={`${option.selector}:${option.label}`}
                className={`dropdown-item ${isHighlighted && "highlight"}`}
                onClick={() => handleSortItemClick(option)}
              >
                {option.selector}:&nbsp;
                {option.label}
              </button>
            );
          })}
        </div>
      </OutsideClickHandler>
    </div>
  );
};
